import React, {Fragment, useEffect, useState} from 'react'
import {useTranslation} from 'next-i18next'
import {useRouter} from '_app/hooks/useRouter'
import {addApolloState, initializeApollo} from 'helpers/ApolloHelper/ApolloHelper'
import Page from '_app/components/Page/Page'
import {ProductAttributeFilterInput} from '_app/graphql/generated/graphql'
import {AspectRatio, Box, Container, Flex, Heading, SimpleGrid, Text} from '@chakra-ui/react'
import {CategoriesMenu} from 'modules/Listing/CategoriesMenu'
import {isEmpty} from 'lodash-es'
import {getDimension4, GTM_EVENTS} from '../../_app/utils/dataLayer'
import MobileNavigation from 'modules/Listing/MobileNavigation'
import ImageCms from '_app/components/Content/ImageCms'
import FiltersDropdown from '../../modules/Listing/Filters/FiltersDropdown'
import Sort from 'modules/Listing/Sort'
import { getParams } from 'modules/Listing/utils/init'
import Item from 'modules/Listing/Item'
import Pagination from '../../_app/components/Pagination/Pagination'
import BreakpointsHelper from '../../helpers/BreakpointsHelper/BreakpointsHelper'
import Button from '_app/components/Buttons/Button'
import {useSearchParams} from 'next/navigation'
import {Context} from '../../_app/types/context'
import withAppInit from '../../_app/hoc/withAppInit'
import ProductHelper from '../../helpers/ProductHelper/ProductHelper'
import {GET_CATEGORY_DOCUMENT} from '../../_app/graphql/queries/category/GetCategory'
import SeoHelper from '../../helpers/SeoHelper/SeoHelper'
import I18nHelper from '../../helpers/I18nHelper/I18nHelper'
import {GetListingProductsDocument} from '../../_app/graphql/queries/products/GetProductsList'
import {URL_RESOLVER} from '../../_app/graphql/queries/URLResolver'
import URLHelper from '../../helpers/URLHelper/URLHelper'

const Category = () => {
    const {t} = useTranslation('listing')
    const router = useRouter()
    const { asPath, locale } = router
    const asPathNoneHtml = asPath?.replace('.html', '')
    const asMagentoPath = asPathNoneHtml?.search('\\?') >= 0 ? asPathNoneHtml?.split('?')[0] : asPathNoneHtml
    const apolloClient = initializeApollo(null, { locale })
    const searchParams = useSearchParams()
    const [loading, setLoading]: any = useState(true)
    const [currentPage, setCurrentPage]: any = useState(null)
    const [order, setOrder]: any = useState('')
    const [filters, setFilters]: any = useState(null)
    const [title, setTitle]: any = useState(null)
    const [description, setDescription]: any = useState(null)
    const [coverImage, setCoverImage]: any = useState(null)
    const [category, setCategory]: any = useState({})
    const [productItems, setProductItems]: any = useState(null)
    const [productsCount, setProductsTotalCount]: any = useState(0)
    const [pageInfo, setPageInfo]: any = useState(null)
    const [currencyCode, setCurrencyCode]: any = useState(null)
    const [navigation, setNavigation]: any = useState({
        title: category?.name ?? '',
        mainUrl: category?.url_path ?? '',
        items: category?.children ?? [],
    })
    const handleCategory = async () => {
        const {data }: any = await apolloClient.query({
            query: GET_CATEGORY_DOCUMENT,
            variables: {
                url_path: asMagentoPath?.replace('/', ''),
            },
        })
        const tempData = data?.categories?.items?.[0]
        if (data?.categories?.items?.length === 0) {
            router.push('/404')
        }
        setCategory(tempData)
        setNavigation({
            title: tempData?.name ?? '',
            mainUrl: tempData?.url_path ?? '',
            items: tempData?.children ?? [],
        })
    }
    const handleProducts = async () => {
        setLoading(true)
        let sort = {}
        const orderValues = order && typeof order === 'string' ? order.split('_') : []
        if ((orderValues?.length === 2 && orderValues?.[1] === 'asc') || orderValues?.[1] === 'desc') {
            sort = {[orderValues[0]]: orderValues[1]?.toUpperCase()}
        }
        const productsFilters: ProductAttributeFilterInput = {
            category_id: {
                eq: category?.id?.toString(),
            },
        }
        if (!isEmpty(filters)) {
            const {price, ...restFilters} = filters
            if (price && typeof price === 'string') {
                const priceValues = price?.split('-')
                if (priceValues?.length === 2) {
                    productsFilters.price = {
                        from: priceValues[0],
                        to: priceValues[1],
                    }
                }
            }
            Object.entries(restFilters)?.forEach(([key, value]) => {
                const filterKey = key as keyof ProductAttributeFilterInput
                const filterValue: any = typeof value === 'string' ? [value] : value
                productsFilters[filterKey] = {in: filterValue}
            })
        }
        if (productsFilters?.category_id?.eq) {
            const {data: dataTemp} = await apolloClient.query({
                query: GetListingProductsDocument,
                variables: {
                    currentPage: currentPage || 1,
                    filter: productsFilters,
                    sort,
                },
            })
            const productsData = dataTemp?.products
            await setProductsTotalCount(productsData?.total_count)
            await setProductItems(productsData?.items)
            await setCurrencyCode(productsData?.items?.[0]?.price_range?.minimum_price?.final_price?.currency)
            await setPageInfo(productsData?.page_info)
            await setCurrentPage(productsData?.page_info?.current_page)
            setLoading(false)
        }
    }
    const specialPricesCanonical = () => {
        let routerPath = ''
        if (category?.id === 362) {
            routerPath = '/sklep/bizuteria/bransoletki.html'
            return URLHelper.translateHref(routerPath, router?.locale) as string
        }
        if (category?.id === 377) {
            routerPath = '/sklep/bizuteria/kolczyki.html'
            return URLHelper.translateHref(routerPath, router?.locale) as string
        }
        if (category?.id === 390) {
            routerPath = '/sklep/bizuteria/naszyjniki.html'
            return URLHelper.translateHref(routerPath, router?.locale) as string
        }
        if (category?.id === 1214) {
            routerPath = '/sklep/bizuteria/pierscionki.html'
            return URLHelper.translateHref(routerPath, router?.locale) as string
        }
        if (category?.id === 1299) {
            routerPath = '/sklep/bizuteria/zawieszki.html'
            return URLHelper.translateHref(routerPath, router?.locale) as string
        }
        if (category?.id === 1619) {
            routerPath = '/sklep/torebki-i-akcesoria.html'
            return URLHelper.translateHref(routerPath, router?.locale) as string
        }
        return URLHelper.translateHref(router?.asPath === '/' ? '' : router?.asPath, router?.locale) as string
    }
    useEffect(() => {
        if (filters) {
            handleCategory()
        }
    }, [filters])
    useEffect(() => {
        if (category && locale) {
            if (locale === 'de') {
                setTitle(`${category?.name} online kaufen | Lilou Paris`)
            } else {
                setTitle(category?.meta_title)
            }
            setCoverImage(category?.image)
            let tempDescription = ''
            // category?.id 37 = Biżuteria
            if (category?.id === 37) {
                switch (locale) {
                    case 'pl':
                        tempDescription = `Wyjątkowa ${category?.name}, która podkreśli Twój wyjątkowy styl. Wybierz spośród szerokiej oferty i zamów online z szybką dostawą!`
                        break
                    case 'de':
                        tempDescription = `Vielfältige ${category?.name} bei Lilou Paris entdecken ✓ viele Materialien & Designs ✓ sofort lieferbar ✓ 14 Tage Rückgabe ➤ jetzt ${category?.name} shoppen`
                        break
                    case 'fr':
                        tempDescription = `Des ${category?.name} uniques qui mettra en valeur votre style. Choisissez parmi une large gamme et commandez en ligne avec une livraison rapide !`
                        break
                    case 'en':
                        tempDescription = `Unique ${category?.name} that will highlight your unique style. Choose from a wide selection and order online with fast delivery!`
                        break
                    default:
                        tempDescription = `Wyjątkowa ${category?.name}, która podkreśli Twój wyjątkowy styl. Wybierz spośród szerokiej oferty i zamów online z szybką dostawą!`
                        break
                }
            } else {
                switch (locale) {
                    case 'pl':
                        tempDescription = `Wyjątkowe ${category?.name}, które podkreślą Twój wyjątkowy styl. Wybierz spośród szerokiej oferty i zamów online z szybką dostawą!`
                        break
                    case 'de':
                        tempDescription = `Vielfältige ${category?.name} bei Lilou Paris entdecken ✓ viele Materialien & Designs ✓ sofort lieferbar ✓ 14 Tage Rückgabe ➤ jetzt ${category?.name} shoppen`
                        break
                    case 'fr':
                        tempDescription = `Des ${category?.name} uniques qui mettra en valeur votre style. Choisissez parmi une large gamme et commandez en ligne avec une livraison rapide !`
                        break
                    case 'en':
                        tempDescription = `Unique ${category?.name} that will highlight your unique style. Choose from a wide selection and order online with fast delivery!`
                        break
                    default:
                        tempDescription = `Wyjątkowe ${category?.name}, które podkreślą Twój wyjątkowy styl. Wybierz spośród szerokiej oferty i zamów online z szybką dostawą!`
                        break
                }
            }
            setDescription(tempDescription)
        }
    }, [category, locale])
    useEffect(() => {
        if (searchParams) {
            const p = parseInt(searchParams?.get('p') as string) ?? 1
            const o = searchParams?.get('order')
            const price = searchParams.get('price')
            const material_swatch = searchParams.get('material_swatch')
            const kolor3_swatch = searchParams.get('kolor3_swatch')
            const kolor_emalii_swatch = searchParams.get('kolor_emalii_swatch')
            const filtersUrl = {}
            if (price) {
                filtersUrl['price'] = price
            }
            if (material_swatch) {
                filtersUrl['material_swatch'] = material_swatch
            }
            if (kolor_emalii_swatch) {
                filtersUrl['kolor_emalii_swatch'] = kolor_emalii_swatch
            }
            if (kolor3_swatch) {
                filtersUrl['kolor3_swatch'] = kolor3_swatch
            }
            setFilters(filtersUrl)
            setCurrentPage(p)
            setOrder(o)
        }
    }, [searchParams])
    useEffect(() => {
        if (category && filters) {
            handleProducts()
        }
    }, [category, filters])
    useEffect(() => {
        if (category?.name) {
            GTM_EVENTS.impressionView({
                ecommerce: {
                    currencyCode: currencyCode || 'PLN',
                    impressions: (productItems || []).map((product) => {
                        return ({
                                list: category?.name,
                                id: product.sku,
                                name: product.name,
                                price: product.price_range.minimum_price.final_price.value,
                                brand: 'Lilou',
                                category1: product?.main_category?.[0]?.name,
                                category2: 'Nieokreślone',
                                dimension6: ProductHelper.getNameAvailable(ProductHelper.getAvailableAmount(product?.items, undefined, product?.salable_qty, product)),
                                dimension4: getDimension4(product.categories),
                            })
                        }
                    ),
                },
            })
        }
    }, [asPath, category?.name, currencyCode, productItems])
    return (
        <Page
            seo={{
                title: SeoHelper.getTitle(title),
                description: SeoHelper.getDescription(description),
                openGraph: {images: [{url: coverImage}]},
            }}
            customCanonical={specialPricesCanonical()}
            isLoading={loading}
        >
            {
                BreakpointsHelper.isMobile() && (
                    <MobileNavigation
                        categoryUid={category?.uid || ''}
                        activeFilters={filters}
                        order={order}
                        category={category}
                        navigation={navigation}
                    />
                )
            }
            <Container py={{base: 4, md: 10}}>
                <Flex sx={{ display: 'flex', flexDirection: BreakpointsHelper.isMobile() ? 'column' : 'row'}}>
                    <CategoriesMenu navigation={navigation} category={category}/>
                    <Box
                        flexBasis={{
                            base: '100%',
                            lg: '75%',
                        }}
                        maxW={{
                            base: '100%',
                            lg: '75%',
                        }}
                        position="relative"
                    >
                        {coverImage && (
                            <Box mb="2.75rem" display={{base: 'none', md: 'block'}}>
                                <AspectRatio ratio={1050 / 290} w="full" position="relative">
                                    <ImageCms
                                        src={''}
                                        attributes={{
                                            url: coverImage,
                                        }}
                                        alt="listing image"
                                        priority={true}
                                    />
                                </AspectRatio>
                            </Box>
                        )}

                        <Flex
                            justifyContent="space-between"
                            mb={{base: 3, lg: 6}}
                            flexDirection={{base: 'column', lg: 'row'}}
                            gap={{base: 0, lg: 6}}
                        >
                            <Flex
                                gap={{base: 2, lg: 6}}
                                alignItems={{base: 'flex-start', lg: 'center'}}
                                flexDirection={{base: 'column', lg: 'row'}}
                                justifyContent={{base: 'space-between', lg: 'flex-start'}}
                            >
                                <Heading
                                    as="h1"
                                    textStyle="h2"
                                    fontSize={{base: '1.5rem', lg: '2rem'}}
                                    marginBottom={0}
                                >
                                    {category?.header_name || category?.name}
                                </Heading>
                                <Text textStyle="bodyLight" minW="fit-content" display="flex">
                                    {t('PRODUCT_QUANTITY')}: {productsCount}
                                </Text>
                            </Flex>
                            <Flex
                                alignItems="center"
                                gap={6}
                                display={{base: 'none', lg: 'flex'}}
                            >
                                <FiltersDropdown
                                    categoryUid={category?.uid}
                                    activeFilters={filters}
                                />
                                <Sort active={order}/>
                            </Flex>
                        </Flex>
                        {productItems?.length > 0 ? (
                            <>
                                <SimpleGrid
                                    columns={{
                                        base: 1,
                                        lg: 3,
                                    }}
                                    spacing="1.875rem"
                                >
                                    {productItems?.map((item, index) => (
                                        <Item
                                            key={index}
                                            item={item}
                                            category={category}
                                            position={index + 1}
                                            showCarousel
                                        />
                                    ))}
                                </SimpleGrid>
                                <Pagination {...pageInfo} mt={15}/>
                            </>
                        ) : (
                            <Flex
                                w="20.625rem"
                                mx="auto"
                                maxW="100%"
                                flexDir="column"
                                my={{
                                    base: 12,
                                    lg: '5.625rem',
                                }}
                                gap={3}
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Text
                                    textStyle="h4"
                                    fontSize={{
                                        base: '1.125rem',
                                        lg: '1.25rem',
                                    }}
                                    mb={3}
                                    whiteSpace="pre-wrap"
                                >
                                    {t('SORRY_WE_DONT_HAVE_THE_PRODUCTS')}
                                </Text>
                                <Button
                                    onClick={() => router.push('/')}
                                    variant="outline"
                                    minWidth={{
                                        base: '100%',
                                        lg: '13.125rem',
                                    }}
                                >
                                    {t('CREATE_YOUR_TALISMAN')}
                                </Button>
                                <Button
                                    onClick={() => router.push('/')}
                                    variant="outline"
                                    minWidth={{
                                        base: '100%',
                                        lg: '13.125rem',
                                    }}
                                >
                                    {t('BESTSELLERS')}
                                </Button>
                            </Flex>
                        )}
                    </Box>
                </Flex>
                 {
                    category?.description && (
                        <Box className="postContent" dangerouslySetInnerHTML={{__html: category?.description}}/>
                    )
                 }
            </Container>
        </Page>
    )
}

export const getServerSideProps = withAppInit(async (ctx: Context) => {
    const { urlPath } = getParams(ctx)
    const apolloClient = initializeApollo(null, { locale: ctx.locale })
    const dataURL = await apolloClient.query({
        query: URL_RESOLVER,
        variables: {
            url: `${urlPath}.html`,
        },
    })
    const url = dataURL?.data?.resolveCustomRedirect?.target_path
    const statusCode = Number(dataURL?.data?.resolveCustomRedirect?.redirect_type)
    if (url && (statusCode === 301 || statusCode === 302)) {
        return {
            redirect: {
                destination: `/${url}`,
                statusCode: statusCode || 301,
            },
        }
    }
    return addApolloState(ctx.apolloClient, {
        props: {
            ...(await I18nHelper.getI18nProps(ctx, [
                'listing',
                'engraving',
                'cart',
            ])),
        },
    })
})

export default Category
